import * as React from "react";
import PropTypes from "prop-types";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FilterListIcon from "@mui/icons-material/FilterList";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import SubTable from "./SubTable";
import LeaveStyle from "../../Components/LeavesStyle";
import { Card, Typography as typography_antd } from "antd";
import { useState } from "react";
import "./employeeavailability.css";
// import { addMonths, endOfMonth, format, startOfMonth } from "date-fns/esm";
import moment from "moment";
import { useEffect } from "react";
import env from "../../config/env";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllUserData } from "../../redux/slice/getAllUserData";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DateRangePicker, InputGroup } from "rsuite";
import { Calendar } from "@rsuite/icons";
// import "rsuite/dist/rsuite.min.css";
import { addMonths, startOfMonth, endOfMonth, startOfYear, endOfYear, format } from "date-fns";
import { Height, TextFields } from "@mui/icons-material";
import InputGroupAddon from "rsuite/esm/InputGroup/InputGroupAddon";
import { FormattedDate } from "rsuite/esm/CustomProvider";
import CryptoJS from "crypto-js";

const { Title } = typography_antd;
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY

const startMonth = startOfMonth(new Date());
const today_Date = moment(new Date()).format("YYYY-MM-DD");

function Availability() {
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(true);
  const [startDate, setstartDate] = useState(format(startMonth, "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(today_Date);
  const [availability, setAvailability] = useState([]);
  const [filterDetails, setFilterDetails] = useState([]);
  const [users, setUsers] = useState([]);
  const [userfilter, setUserfilter] = useState([]);
  const [selectedUserCheckboxes, setSelectedUserCheckboxes] = useState([]);
  const [openFilterModal, setopenFilterModal] = useState(false);
  const [Filtervalue, setFilterValue] = useState(0);
  const [count, setCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromWorkingHour, setFromWorkingHour] = useState(0);
  const [toWorkingHour, setToWorkingHour] = useState(12 * 3600);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  // tracker
  const [tracker, setTracker] = useState("All");
  const [leave, setLeave] = useState("All");
  // const All = "All";
  // // this is new Start and end date state
  // const [startD, setStartD] = useState(
  //   new Date(new Date().getFullYear(), 0, 1)
  // );

  // const [endD, setEndD] = useState(
  //   new Date(new Date().getFullYear(), 11, 31)
  // );
  // Active Arr
  // const [activityArr, setActivityArr] = useState([]);
  // if(state?.getAllUserData?.data?.status === 555 || state?.getAllUserData?.data?.status === 501){
  //   dispatch(setToken(null));      
  //     dispatch(setUserData(null));
  // toast.error("Session expire, Please LogIn!", {
  //   position: toast.POSITION.TOP_RIGHT,
  //   toastId: "1",
  // });
  //     Navigate("/login")
  // }
  let userData = state?.getAllUserData?.data;

  useEffect(() => {
    if (token) {
      dispatch(fetchAllUserData(token));
      // fetchData()
    }
  }, [token]);

  useEffect(() => {

    console.log(userData, "ysgrfgue")

    if (userData) {

      const arr = []
      userData?.map((val) => {
        if (val.role_id !== 3) {
          arr.push({ name: val?.name })
        }
      })
      setUsers(arr);
      setFilterDetails(arr);
      setUserfilter(arr);

    }
  }, [userData])

  console.log(filterDetails, "hgjhgfjhfyh")

  useEffect(() => {
    fetchData();
  }, [startDate, endDate, fromWorkingHour, toWorkingHour, tracker, leave]);

  const encodedUsernames =
    selectedUserCheckboxes.length > 0
      ? encodeURIComponent(JSON.stringify(selectedUserCheckboxes))
      : "";

  const fetchData = async () => {
    try {
      setLoading(true);


      //Encrypt api endpoint
      const getAllAttendance = CryptoJS.SHA256("/getAllAttendance" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      // Encrypt data
      function encryptData(data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
      }

      const encryptedName = encodeURIComponent(encryptData(encodedUsernames));
      const encryptedTracker = encodeURIComponent(encryptData(tracker.includes('All') ? "" : tracker));
      const encryptedLeave = encodeURIComponent(encryptData(leave.includes('All') ? "" : leave))
      const encryptedStartDate = encodeURIComponent(encryptData(startDate));
      const encryptedEndtDate = encodeURIComponent(encryptData(endDate));
      const encryptedFromWorkingHour = encodeURIComponent(encryptData(fromWorkingHour));
      const encryptedToWorkingHour = encodeURIComponent(encryptData(toWorkingHour));

      const response = await fetch(
        `${env.backend_api_endpoint}/${getAllAttendance}?startDate=${encryptedStartDate}&endDate=${encryptedEndtDate}&username=${encryptedName}&minTotalWorkingHours=${encryptedFromWorkingHour}&maxTotalWorkingHours=${encryptedToWorkingHour}&tracker=${encryptedTracker}&leave=${encryptedLeave} `,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
        if (errorData?.status === 400) {
          // setActivityArr([]);
          setFilterDetails([]);
          setLoading(false);
        }
        throw new Error("Error fetching attendance details");
      }
      let data = [];
      data = await response.json();

      const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      // data = data.filter((record) => {
      //   const recordDate = new Date(record.date);
      //   const day = recordDate.getDay(); // 0 = Sunday, 6 = Saturday
      //   const isWeekend = day === 0 || day === 6;
      //   const hasPunchIn = record.punch_in && record.punch_out !== "";

      //   // Only hide records that are AFTER deactivation date (not all)
      //   if (record.deactivated_date) {
      //     const deactivatedDate = new Date(record.deactivated_date);

      //     // Exclude records after deactivation date
      //     if (recordDate > deactivatedDate) {
      //       return false;
      //     }
      //   }

      //   // For weekends, only show if there's punch-in/punch-out
      //   if (isWeekend) {
      //     return hasPunchIn;
      //   }

      //   // Otherwise show the record (weekdays)
      //   return true;
      // });

      data = decryptedData.map((record) => {
        const recordDate = new Date(record.date);
        const day = recordDate.getDay(); // 0 = Sunday, 6 = Saturday
        const isWeekend = day === 0 || day === 6;

        const filteredUsers = record.users.filter((user) => {
          // const deactiveDate = user.deactivated_date ? new Date(user.deactivated_date) : null;

          // Exclude records after deactivation date
          // if (deactiveDate && recordDate > deactiveDate) {
          //   return false;
          // }

          // Weekend filtering
          const punch = user.data?.[0];
          const hasPunch = punch?.punch_in && punch?.punch_out;

          if (isWeekend) {
            return hasPunch;
          }

          return true;
        });

        return {
          ...record,
          users: filteredUsers,
        };
      }).filter((record) => record.users.length > 0);


      setAvailability(data);
      // setActivityArr(data);
      setFilterDetails(data);
      setCount(1);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attendance details:", error.message);
    }
  };

  const handleTChange = (event, newValue) => {
    setFilterValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const FilterPopup = () => {
    setopenFilterModal(true);
  };

  const handleDateChange = (e) => {
    if (e.$d !== null) {
      const newStartDate = moment(e.$d).format("YYYY-MM-DD");
      setstartDate(newStartDate);
    }
  };

  const handleToDateChange = (e) => {
    const newEndDate = moment(e.$d).format("YYYY-MM-DD");
    setEndDate(newEndDate);
  };

  const handleFilterYear = (key) => {
    if (key == 1) {
      setstartDate(format(startMonth, "yyyy-MM-dd"));
      setEndDate(today_Date);
    }
    if (key == 2) {
      setstartDate(
        format(startOfMonth(addMonths(new Date(), -1)), "yyyy-MM-dd")
      );
      setEndDate(format(endOfMonth(addMonths(new Date(), -1)), "yyyy-MM-dd"));
    }
    if (key == 3) {
      setstartDate(moment().startOf("year").format("YYYY-MM-DD"));
      setEndDate(today_Date);
    }
    if (key == 4) {
      setstartDate(
        moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD")
      );
      setEndDate(
        moment().subtract(1, "year").endOf("year").format("YYYY-MM-DD")
      );
    }
  };

  const filterdsumbit = () => {
    setLoading(true);
    fetchData();
    setopenFilterModal(false);
  };

  const handleClearFilter = () => {
    setstartDate(format(startMonth, "yyyy-MM-dd"));
    setEndDate(today_Date);
    setCount(0);
    setopenFilterModal(false);
    setSearchQuery("");
    setUserfilter(users);
    setFromWorkingHour(0);
    setToWorkingHour(12 * 3600);
    fetchData();
    setSelectedUserCheckboxes([]);
  };

  const closeFilterModel = () => {
    setopenFilterModal(false);
    setSearchQuery("");
    setUserfilter(users);
  };

  const handleSearchChange = (e) => {

    const searchText = e.target.value;
    setSearchQuery(searchText);

    if (searchText !== "") {
      const filteredData = users?.filter((row) =>
        row.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setUserfilter(filteredData);
    } else {
      setUserfilter(users);
    }
  };

  const handleUserChange = (name) => {
    const Selectedname = selectedUserCheckboxes.includes(name)
      ? selectedUserCheckboxes.filter((item) => item !== name)
      : [...selectedUserCheckboxes, name];
    setSelectedUserCheckboxes(Selectedname);
  };

  // search 
  const handleSearch = (e) => {
    const searchText = e.target.value.toLowerCase();
    setSearchQuery(searchText);

    if (!searchText) {
      setFilterDetails(availability) //reset the full data if search is clear
      return;
    }

    const filteredData = availability.map((record) => {
      const matchUser = record.users.filter((user) =>
        user?.userName?.toLowerCase().includes(searchText)
      );
      if (matchUser.length > 0) {
        return {
          ...record,
          users: matchUser,
        };
      }
      return null;
    }).filter((record) => record !== null);
    setFilterDetails(filteredData);
  }

  // Min
  const handleChange = (e) => {
    const selectedHour = parseInt(e.target.value);
    const seconds = selectedHour * 3600;
    setFromWorkingHour(seconds);
    fetchData();
  };

  // Max
  // const handleChangeTo = (e) => {
  //   const selectedHour = parseInt(e.target.value);
  //   const seconds = selectedHour * 3600;
  //   setToWorkingHour(seconds);
  //   fetchData();
  // };

  // predefine ranges
  const now = new Date();

  const predefineRanges = [
    {
      label: 'This Month',
      value: [
        new Date(now.getFullYear(), now.getMonth(), 1),
        now
      ]
    },
    {
      label: 'This Year',
      value: [
        new Date(now.getFullYear(), 0, 1),
        now
      ]
    },
    {
      label: 'Last Month',
      value: [
        new Date(now.getFullYear(), now.getMonth() - 1, 1),
        new Date(now.getFullYear(), now.getMonth(), 0),
      ]
    },
    {
      label: 'Last Year',
      value: [
        new Date(now.getFullYear() - 1, 0, 1),
        new Date(now.getFullYear() - 1, 11, 31)
      ]
    }
  ]

  // holds formated date string
  const [dateRange, setDateRange] = useState(predefineRanges[0].value)
  const handleRangeChange = ([start, end]) => {
    setDateRange([start, end]);
    setstartDate(format(start, "yyyy-MM-dd"));
    setEndDate(format(end, "yyyy-MM-dd"));
  }

  const handleFilterdSumbit = () => {
    fetchData();
  }
  // close 

  const handleCloseFilter = () => {
    const now = new Date()
    const start = new Date(now.getFullYear(), now.getMonth(), 1)
    const end = now

    setstartDate(format(start, "yyyy-MM-dd"));
    setEndDate(format(end, "yyyy-MM-dd"));
    fetchData();
  }

  return (
    <>
      <LeaveStyle>
        <div className="site-card-border-less-wrapper">
          <Card
            bodyStyle={{ height: "calc(100vh - 75px)", padding: "10px" }}
            bordered={false}
            style={{
              margin: 10,
            }}
          >
            <div className="AllEmployeeHeaderWrapper" style={{ padding: "0px" }}>
              <div className="AllEmployeeHeader">
                <div className="HeaderTitle ">
                  <Title level={2} style={{ fontWeight: 500 }} className="employee_availability_heading">
                    Employee Availability
                  </Title>
                  {/* <div className="iconFilterDown" style={{ marginTop: "0px" }}>
                    <FilterListIcon onClick={FilterPopup} />
                  </div> */}
                </div>
              </div>
            </div>
            <div className="card bg-light border-2 rounded-lg shadow-sm p-4 mb-6" >
              <div className="flex flex-wrap align-items-center gap-4" style={{ fontFamily: "MilliardBook" }}>
                {/* search bar */}
                <TextField
                  placeholder="Search Employees Leaves..."
                  value={searchQuery}
                  // fullWidth
                  onChange={handleSearch}
                  style={{
                    width: "53%",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    paddingRight: "1%",
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    sx: {
                      height: 40,
                      fontFamily: "Milliard"
                    },
                  }}
                />
                {/* Filter by tracker status */}
                <Box sx={{ minWidth: 140 }} boxSizing={"content-box"}
                  style={{
                    // width: "full",
                    // paddingLeft: "16px",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    paddingRight: "1%",
                  }}>

                  <TextField
                    select
                    fullWidth
                    id='tracker'
                    label='Status Tracker'
                    value={tracker}
                    onChange={(e) => setTracker(e.target.value)}
                    sx={{
                      height: 40,
                      '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
                        padding: '8.5px 14px'
                      }
                    }}

                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="running">Running</MenuItem>
                    <MenuItem value="stopped">Stopped</MenuItem>
                    <MenuItem value="in_break">In-Break</MenuItem>
                    <MenuItem value="not_started">Not Started</MenuItem>
                  </TextField>
                  {/* <FormControl fullWidth>
                    <Select
                      id="tracker"

                      displayEmpty
                      value={tracker}
                      onChange={e => { setTracker(e.target.value); console.log("target", e.target.value) }}
                      sx={{
                        height: 40,
                      }}
                    >
                      <MenuItem value="">All</MenuItem>
                      <MenuItem value="running">Running</MenuItem>
                      <MenuItem value="stopped">Stopped</MenuItem>
                      <MenuItem value="in_break">In-Break</MenuItem>
                      <MenuItem value="not_started">Not Started</MenuItem>
                    </Select>

                  </FormControl> */}
                </Box>
                {/* leave status  */}
                <Box sx={{ minWidth: 140 }} boxSizing={"content-box"}
                  style={{
                    // width: "full",
                    // paddingLeft: "16px",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    paddingRight: "1%",
                  }}>

                  <TextField
                    select
                    fullWidth
                    id='leave'
                    label='Leave Status'
                    value={leave}
                    onChange={(e) => { setLeave(e.target.value); console.log("leave", e.target.value) }}
                    sx={{
                      height: 40,
                      '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
                        padding: '8.5px 14px'
                      }
                    }}

                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="available">Available</MenuItem>
                    <MenuItem value="first_half">First-Half</MenuItem>
                    <MenuItem value="second_half">Second-Half</MenuItem>
                    <MenuItem value="full_day">Full-Day</MenuItem>
                  </TextField>
                  {/* <FormControl fullWidth>
                    <Select
                      id="tracker"

                      displayEmpty
                      value={tracker}
                      onChange={e => { setTracker(e.target.value); console.log("target", e.target.value) }}
                      sx={{
                        height: 40,
                      }}
                    >
                      <MenuItem value="">All</MenuItem>
                      <MenuItem value="running">Running</MenuItem>
                      <MenuItem value="stopped">Stopped</MenuItem>
                      <MenuItem value="in_break">In-Break</MenuItem>
                      <MenuItem value="not_started">Not Started</MenuItem>
                    </Select>

                  </FormControl> */}
                </Box>
                {/* filter by range  */}
                < Box sx={{ minWidth: 140 }} boxSizing={"content-box"}
                  style={{
                    // width: "full",
                    // paddingLeft: "16px",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    paddingRight: "1%",
                  }}
                >
                  <style>
                    {`
                      
                        .rs-picker-toggle-value{
                          color: black !important ;
                        }
                         .rs-picker-toggle.rs-btn {
                            color: black ;
                            height: 40px !important; 
                            border: 1px solid #c4c4c4 !important; 
                            border-radius: 4px !important;
                            box-shadow: none !important;
                            display: flex;
                            align-items: center;
                          }

                          /*set border color to black at time of hover*/
                          .rs-picker-toggle.rs-btn:hover {
                            border-color: black !important;
                          }

                          /* When the input is focused (selected), set the border color to blue */
                          .rs-picker-toggle-textbox{
                            border:  1px solid #1675e0 !important;
                            padding: 1px 10px !important;
                          }      
                          
                          .rs-stack-item .rs-picker-toggle-caret{
                            display: none !important;
                          }

                          .rs-picker-default .rs-picker-toggle{
                            padding-right: 11px !important;
                          }
                        
                    `}

                  </style>
                  <DateRangePicker
                    cleanable={false}
                    ranges={predefineRanges}
                    value={dateRange}
                    onChange={handleRangeChange}
                    renderValue={(value) => {
                      const [start, end] = value;
                      return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <Calendar />
                          {format(start, 'dd-MM-yyyy')} ~ {format(end, 'dd-MM-yyyy')}
                        </span>
                      )
                    }}
                    showOneCalendar
                    onOk={handleFilterdSumbit}
                    format="dd-MM-yyyy"
                    onKeyDown={(e) => {
                      if (!/[0-9/]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />

                </Box>
                {/* min */}
                {/* <Box sx={{ minWidth: 140, }} boxSizing={"content-box"}
                  style={{
                    // width: "full",
                    // paddingLeft: "16px",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    paddingRight: "1%",
                  }}
                >
                  <TextField
                    select
                    label='Min'
                    // labelId="demo-simple-select-label"

                    id="demo-simple-select"
                    value={fromWorkingHour / 3600}
                    onChange={(e) => handleChange(e)}
                    style={{ width: "140px" }}
                    sx={{

                      '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
                        padding: '8.5px 14px'
                      }
                    }}
                  // MenuProps={{
                  //   PaperProps: {
                  //     style: {
                  //       maxHeight: 150,

                  //     },
                  //   },
                  // }}
                  >

                    {[...Array(13).keys()].map((value) => (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box> */}

                {/* Max */}
                {/* <Box sx={{ minWidth: 140, }} boxSizing={"content-box"}
                  style={{
                    // width: "full",
                    // paddingLeft: "16px",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    paddingRight: "1%",
                  }}
                >
                  <TextField
                    select
                    label='Max'
                    // labelId="demo-simple-select-label"

                    id="demo-simple-select"
                    value={toWorkingHour / 3600}
                    onChange={(e) => handleChangeTo(e)}
                    style={{ width: "140px" }}
                    sx={{

                      '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
                        padding: '8.5px 14px'
                      }
                    }}
                  // MenuProps={{
                  //   PaperProps: {
                  //     style: {
                  //       maxHeight: 150,

                  //     },
                  //   },
                  // }}
                  >

                    {[...Array(13).keys()].map((value) => (
                      <MenuItem key={value} value={value}>
                        {value}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box> */}

              </div>
            </div>

            <div className="All_employee_table  attendance-box" style={{ padding: "5px", height: "80vh", maxHeight: 'calc(100vh - 210px)' }}>
              {!loading ? (
                <>
                  {filterDetails.length > 0 ? (
                    filterDetails?.map((arrVal) => {
                      const tem = new Date(arrVal?.date);
                      const a = moment(tem, "DD-MM-YYYY");
                      const date = new Date(a);
                      let mdate = moment(date);
                      const day = mdate.format("dddd");
                      const onlyDate = mdate.format("DD");
                      const month = mdate.format("MMMM");
                      return (
                        <>
                          <Typography
                            variant="h1"
                            gutterBottom
                            className="temp-Date"
                            sx={{ marginTop: "10px" }}
                          >
                            {day},{onlyDate} {month}
                          </Typography>

                          <TableContainer
                            component={Paper}
                            // className="table-container"
                            style={{
                              // overflowY: 'auto',
                              width: '100%',
                              borderTopLeftRadius: 15,
                              borderTopRightRadius: 15,
                              borderBottomLeftRadius: 0,
                              borderBottomRightRadius: 0
                            }}
                          >
                            <Table
                              sx={{
                                minWidth: 650,
                                '& th, & td': {
                                  border: '1px solid #f0f0f0',
                                },
                              }}
                              aria-label="collapsible table"
                            >
                              <TableHead className="table_Header_color" sx={{ height: "50px" }}>
                                <TableRow style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                  backgroundColor: "#244DA0",
                                }}>
                                  <TableCell
                                    // align="left"
                                    // className="font_bold"
                                    style={{ width: "20%", color: "white" }}
                                  >
                                    Employee
                                  </TableCell>

                                  <TableCell
                                    // align="center"
                                    // className="font_bold"
                                    style={{ width: "17%", color: "white" }}
                                  >
                                    Status
                                  </TableCell>

                                  {/* <TableCell
                                    align="center"
                                    // className="font_bold"
                                    style={{ width: "10%", color:"white" }}
                                  >
                                    Leave Status
                                  </TableCell> */}

                                  <TableCell
                                    // align="center"
                                    // className="font_bold"
                                    style={{ width: "20%", color: "white" }}
                                  >
                                    Punch In/Out
                                  </TableCell>

                                  <TableCell
                                    // align="center"
                                    // className="font_bold"
                                    style={{ width: "20%", color: "white" }}
                                  >
                                    Break Time
                                  </TableCell>

                                  <TableCell
                                    // align="center"
                                    // className="font_bold"
                                    style={{ width: "20%", color: "white" }}
                                  >
                                    Working Hours
                                  </TableCell>

                                  {/* <TableCell
                                    style={{ width: "20%", color:"white" }}
                                    align="center"
                                  /> */}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {arrVal?.users?.map((userVal) => (
                                  <SubTable userData={userVal} />
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </>
                      );
                    })
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <p style={{ textAlign: "center" }}>No records found.</p>
                    </div>
                  )}
                </>
              ) : (
                <span class="loader"></span>
              )}
            </div>

            {/* Filter Model */}
            {/* <Dialog open={openFilterModal} className="filter_model">
              <DialogTitle
                id="Leave_title"
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                Filters
                <div>
                  <Button
                    onClick={handleClearFilter}
                    style={{
                      backgroundColor: "#244DA0",
                      borderRadius: "6px",
                      color: "white",
                      fontWeight: "500",
                      borderColor: "#244DA0",
                      padding: "5px 25px",
                      textTransform: "none",
                    }}
                  >
                    Clear All
                  </Button>
                </div>
              </DialogTitle>
              <Divider />
              <DialogContent>
                <div className="filter_Dialog_employee">
                  <Box
                    sx={{
                      flexGrow: 1,
                      bgcolor: "background.paper",
                      display: "flex",
                      height: 224,
                    }}
                  >
                    <Tabs
                      orientation="vertical"
                      variant="scrollable"
                      value={Filtervalue}
                      onChange={handleTChange}
                      aria-label="Vertical tabs example"
                      sx={{ borderRight: 1, borderColor: "divider" }}
                      className="tab_div"
                    >
                      <Tab label="Name" sx={{ textTransform: "none" }} />
                      <Tab label="Date" sx={{ textTransform: "none" }} />
                      <Tab
                        label="Working Hours"
                        sx={{
                          textTransform: "none",
                          width: "90px",
                          wordWrap: "break-word",
                        }}
                      />
                    </Tabs>
                    <div>
                      {Filtervalue === 0 ? (
                        <div className="SearchInput">
                          <TextField
                            className="SearchInput"
                            id="r5"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon style={{ color: "lightgray" }} />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      <TabPanel
                        value={Filtervalue}
                        className="Tab_Panel"
                        index={0}
                      >
                        <div>
                          {userfilter?.length !== 0
                            ? userfilter?.map((ele) => {
                              return (
                                <li className="filter_list">
                                  <Checkbox
                                    checked={selectedUserCheckboxes.includes(
                                      ele.name
                                    )}
                                    onChange={() =>
                                      handleUserChange(ele.name)
                                    }
                                    name={ele?.name}
                                    style={{
                                      padding: "0px",
                                      marginRight: "10px",
                                      color: "darkgray",
                                    }}
                                  />
                                  {ele.name}
                                </li>
                              );
                            })
                            : "No User Found"}
                        </div>
                      </TabPanel>
                    </div>
                    <TabPanel
                      value={Filtervalue}
                      className="Tab_Panel"
                      index={1}
                    >
                      <div className="DateRange">
                        <div className="mr_div">
                          <Typography className="label_text">
                            From Date <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={dayjs(startDate)}
                              onChange={(e) => handleDateChange(e)}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                        <div>
                          <Typography className="label_text">
                            To Date <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              minDate={dayjs(startDate)}
                              value={dayjs(endDate)}
                              onChange={(e) => handleToDateChange(e)}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                      <div className="d_flex">
                        <span
                          className="bottom_range"
                          onClick={(key) => handleFilterYear(1)}
                        >
                          This Month
                        </span>
                        <span
                          className="bottom_range"
                          onClick={(key) => handleFilterYear(2)}
                        >
                          Last Month
                        </span>
                        <span
                          className="bottom_range"
                          onClick={(key) => handleFilterYear(3)}
                        >
                          This Year
                        </span>
                        <span
                          className="bottom_range"
                          onClick={(key) => handleFilterYear(4)}
                        >
                          Previous Year
                        </span>
                      </div>
                    </TabPanel>

                    <TabPanel
                      value={Filtervalue}
                      className="Tab_Panel"
                      index={2}
                    >
                      <Typography className="label_text_profile">
                        Working Hours
                      </Typography>
                      <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "10px" }}>
                          <Typography className="label_text_profile">
                            Minimum<span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={fromWorkingHour / 3600}
                            onChange={(e) => handleChange(e)}
                            style={{ width: "140px" }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 150,
                                },
                              },
                            }}
                          >
                            {[...Array(13).keys()].map((value) => (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                        <div>
                          <Typography className="label_text_profile">
                            Maximum<span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={toWorkingHour / 3600}
                            onChange={(e) => handleChangeTo(e)}
                            style={{ width: "140px" }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 150,
                                },
                              },
                            }}
                          >
                            {[...Array(13).keys()].map((value) => (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </TabPanel>
                  </Box>
                </div>
              </DialogContent>
              <Divider />
              <DialogActions
                style={{ justifyContent: "space-around", margin: "0px" }}
              >
                <div className="button-container" onClick={closeFilterModel}>
                  <Button
                    block
                    size="large"
                    className="btn_hover_effect"
                    style={{
                      borderRadius: "6px",
                      color: "red",
                      fontWeight: "500",
                      padding: "5px 25px",
                      textTransform: "none",
                    }}
                  >
                    Close
                  </Button>
                </div>
                <div className="button-container" onClick={filterdsumbit}>
                  <Button
                    size="large"
                    block
                    key="back"
                    className="btn_hover_effect"
                    style={{
                      borderRadius: "6px",
                      color: "#244DA0",
                      fontWeight: "500",
                      padding: "5px 25px",
                      textTransform: "none",
                    }}
                  >
                    Apply
                  </Button>
                </div>
              </DialogActions>
            </Dialog> */}
          </Card>
        </div >
      </LeaveStyle >
    </>
  );
}

export default Availability;
